<template>
  <el-row type="flex" class="app-layout orver-hidden-x padding-left-10 padding-right-10">
    <div class="flex-1 flex flex-column event-card">
      <div class="top-btn align-right padding-bottom-10">
        <el-button
          type="primary"
          size="mini"
          @click="$router.push({ name: 'LinkEdit' })"
        >新增事件链路</el-button>
      </div>
      <div class="event-table flex-1 flex flex-column">
        <el-table
          height="100%"
          :key="columns.length"
          :data="tableData"
          v-loading="queryLoading"
          stripe
        >
          <template v-for="(item, index) in columnsList">
            <el-table-column
              v-if="columns[item.label]"
              :width="item.width"
              :min-width="item.minWidth"
              :label="item.label"
              :prop="item.prop"
              :key="index"
              :fixed="item.fixed"
              :sortable="item.sortable"
            >
              <template #default="{ row }" v-if="item.tmpl">
                <template v-if="item.label === '创建时间'">
                  <template>{{ row.createTime | formatTime }}</template>
                </template>
                <template v-if="item.label === '操作'">
                  <el-button
                    size="mini"
                    @click="handleEdit(row)"
                    >编辑</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(row)"
                    >删除</el-button
                  >
                  <el-button size="mini" type="primary" plain @click="handleDetail(row)"
                    >查看链路分析</el-button
                  >
                </template>
              </template>
            </el-table-column>
            <template v-else></template>
          </template>
        </el-table>
        <el-row class="padding-20">
          <el-col align="right">
            <el-pagination
              class="analyze-users-pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="formQuery.pageNum"
              :page-sizes="[20, 50, 100, 200, 300, 400]"
              :page-size="formQuery.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="formQuery.total"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-row>
</template>
<script>
import { mapGetters } from 'vuex';
import { queryEventTrace, deleteEventTrace } from '@/api/event';
import { LogEvent } from '@/data/log';

export default {
  data() {
    return {
      LogEvent,
      queryLoading: false,
      images: [],
      dialogImageUrl: '',
      form: {
        name: '',
      },
      tableData: [],
      columnsList: [
        {
          label: '链路名称',
          minWidth: 150,
          prop: 'traceName',
        },
        {
          label: '创建时间',
          tmpl: true,
        },
        {
          label: '操作',
          tmpl: true,
          minWidth: 150,
        },
      ],
      columns: {
        链路名称: true,
        创建时间: true,
        操作: true,
      },
      formQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  mounted() {
    this.searchTableData();
  },
  watch: {
    source: {
      handler() {
        this.searchTableData();
      },
    },
    env: {
      handler() {
        this.searchTableData();
      },
    },
  },
  methods: {
    handleSizeChange(size) {
      this.formQuery.pageSize = size;
      this.formQuery.pageNum = 1;
      this.searchTableData();
    },
    handleCurrentChange(num) {
      this.formQuery.pageNum = num;
      this.searchTableData();
    },
    async searchTableData(currentPageNum) {
      if (currentPageNum) {
        this.formQuery.pageNum = currentPageNum;
      }
      try {
        this.queryLoading = true;

        // eslint-disable-next-line object-curly-newline
        const { pageNum, pageSize } = this.formQuery;

        const params = {
          pageNum,
          pageSize,
        };

        const {
          data: { list, total },
        } = await queryEventTrace(params);
        this.formQuery.total = total;
        this.tableData.splice(0, this.tableData.length, ...list);
      } finally {
        this.queryLoading = false;
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除此链路?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        await deleteEventTrace({ id: row.id });

        this.$message.success('删除成功');
        this.searchTableData();
      } catch (e) {
        console.log(e);
      }
    },
    handleEdit({
      id, traceName, traceDesc, traceType, traceConfigs,
    }) {
      window.localStorage.setItem('traceConfigs', JSON.stringify(traceConfigs));
      this.$router.push({
        name: 'LinkEdit',
        query: {
          id, traceName, traceDesc, traceType,
        },
      });
    },
    // eslint-disable-next-line object-curly-newline
    handleDetail({ id }) {
      this.$router.push({
        name: 'LinkaAnalysis',
        query: {
          id,
        },
      });
    },
  },
  computed: {
    ...mapGetters('app', ['env', 'source']),
  },
};
</script>
<style lang="scss" scoped>
.app-layout {
  margin-top: 10px;
  height: calc(100vh - 90px);
  flex-direction: column;
  .flex-table {
    flex: 1;
  }
}
.event-card {
  background: #fff;
  padding: 20px;
  &::v-deep {
    .el-card__body {
      height: 100%;
      flex-direction: column;
      display: flex;
    }
  }
}
.edit-form {
  width: 90%;
  margin: 0 auto;
}
</style>
<style lang="scss">
.disabled {
  .el-upload--picture-card {
    display: none !important;
  }
}
</style>
